const proj =  window.location.search.slice(1)
export default proj